<!--
 * @Description:
 * @Date: 2021-07-02 17:59:54
-->
<template>
  <el-dialog
    :visible="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="971px"
    top="15vh"
    :before-close="() => $emit('close')"
  >
    <template slot="title">
      <div class="header">
        自定义数据报告
        <span style="color: red;font-size: 16px;">
          （项目执行周期：{{ startTime }}至{{ endTime }}）
        </span>
      </div>
    </template>
    <div>
      <div class="top">
        <div>
          <span class="title">快捷选择：</span>
          <el-radio-group
            v-model="value1"
            @change="
              e =>
                (value2 = (
                  pickerOptions.customShortcuts.find(
                    i => i.labelValue == e
                  ) || {
                    label: () => {}
                  }
                ).label(startTime))
            "
          >
            <el-radio
              :label="item.labelValue"
              v-for="item in pickerOptions.customShortcuts"
              :key="item.text"
            >
              {{ item.text }}
            </el-radio>
          </el-radio-group>
        </div>
        <div>
          <span class="title">自定义时间：</span>
          <el-date-picker
            align="center"
            v-model="value2"
            type="daterange"
            unlink-panels
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value1 = null"
          ></el-date-picker>
          <el-button
            @click="create"
            type="primary"
            style="margin-left:15px;"
            :disabled="!value2 || isloading"
          >
            {{ isloading ? '生成中' : '生成' }}
          </el-button>
        </div>
      </div>
      <table-render ref="tableRender" :config="config">
        <div
          slot="top-alert"
          style="color:#333333;font-size:14px;margin-bottom:15px;"
        >
          生成记录：
        </div>
      </table-render>
    </div>
  </el-dialog>
</template>
<script>
import { mapState } from 'vuex';
import tableRender from '@/components/tableRender';
import dateFormat from '@/tools/dateFormat';
import { biBase, BIv2 } from '@/api/ajax.js';
import createExtend from '@C/createExtend';
import setBiModule from './data-dialog-bimodule';
import DownloadList from './custom-bi-download-list.vue';

const chartsType = type => {
  const obj = {
    2: 'otc',
    5: 'dcwj',
    7: 'dcwj',
    9: 'gradeHospital',
    10: 'jcyljg',
    20: 'makeScene'
  };
  return obj[type];
};

export default {
  name: 'CustomBi',
  components: { tableRender },
  data() {
    return {
      value1: 1,
      value2: [],
      isloading: false,
      startTime: 0,
      endTime: 0,
      pickerOptions: {
        disabledDate: date => {
          const s = new Date(this.startTime);
          s.setDate(s.getDate() - 1);
          return date < s;
        },
        customShortcuts: [
          {
            text: '截止当前',
            labelValue: 1,
            label(startTime) {
              const end = new Date();
              return [new Date(startTime), end];
            }
          },
          {
            text: '近六个月',
            labelValue: 2,
            label(startTime) {
              const start = new Date();
              const end = new Date();
              start.setMonth(start.getMonth() - 6);
              return [start < new Date(startTime) ? startTime : start, end];
            }
          },
          {
            text: '最近一年',
            labelValue: 3,
            label(startTime) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 12);
              return [start < new Date(startTime) ? startTime : start, end];
            }
          }
        ]
      },
      config: [
        {
          name: '生成记录',
          childMenu: [
            {
              name: '生成记录',
              list: data => {
                if ([5, 20].includes(this.homeProject.projectType)) {
                  return biBase.listTSaasBiCustomReportV2({
                    ...data,
                    projectId: this.$route.query.id
                  });
                }

                return biBase.listTSaasBiCustomReport({
                  ...data,
                  projectId: this.$route.query.id
                });
              },
              fields: [
                {
                  label: '时间段',
                  formatter: row => {
                    if (row.startDt) {
                      return `${row.startDt} - ${row.endDt}`;
                    }
                    return `${row.endDt}`;
                  }
                },
                {
                  label: '生成时间',
                  formatter: row => {
                    return dateFormat(row.createDt);
                  }
                },
                {
                  width: '400px',
                  showToolTip: false,
                  label: '操作',
                  render: (h, ctx, row) => {
                    const {
                      taskRecordStatus,
                      taskRecordUrls,
                      dataStatus,
                      dataUrl,
                      dataurl, // 兼容dataUrl
                      biReportStatus = 0,
                      biStatus = 0 // 新增BI状态， 2可下载，需要与biReportStatus联合判断
                    } = row;
                    const _biStatus = Math.max(biReportStatus, biStatus);
                    const getText = status => {
                      return status == 3
                        ? '生成失败'
                        : status == 2
                        ? '下载'
                        : '生成中';
                    };
                    const open = url => {
                      if (url) {
                        window.open(url, '_blank');
                      }
                    };
                    const getStyle = status => {
                      return {
                        color:
                          status == 3 ? '#FF0000' : status == 2 ? '' : '#666666'
                      };
                    };
                    // ???: 函数最好不要直接使用外部暴漏变量
                    const openBi = () => {
                      // 可配置 调研场景
                      if (
                        +_biStatus === 2 &&
                        [5, 20].includes(+row.projectType)
                      ) {
                        // 如果是下载按钮
                        //点击当期BI报告
                        let form = createExtend(setBiModule, {
                          biInfoId: row.biInfoId,
                          projectId: this.$route.query.id,
                          startDt: row.startDt,
                          endDt: row.endDt
                        });
                        form.$on('remove', async () => {
                          form.remove();
                        });
                        form.$on('confirm', async checkList => {
                          if (!checkList.length) {
                            this.openBi(_biStatus, {
                              downloadId: row.id,
                              biInfoId: row.biInfoId,
                              startDt: row.startDt,
                              endDt: row.endDt
                            });
                            return;
                          }
                          // ???: 之前接口调错
                          await BIv2.updateBiModuleById({
                            projectId: this.$route.query.id,
                            moduleJsonStr: JSON.stringify(checkList)
                          });
                          this.openBi(_biStatus, {
                            downloadId: row.id,
                            biInfoId: row.biInfoId,
                            startDt: row.startDt,
                            endDt: row.endDt
                          });
                        });
                        return;
                      }
                      this.openBi(_biStatus, {
                        downloadId: row.id,
                        biInfoId: row.biInfoId,
                        startDt: row.startDt,
                        endDt: row.endDt
                      });
                    };
                    return (
                      <div>
                        <el-button
                          type="text"
                          style={getStyle(_biStatus)}
                          onClick={openBi}
                        >
                          BI报告{getText(_biStatus)}
                        </el-button>
                        <el-button
                          type="text"
                          style={getStyle(taskRecordStatus)}
                          disabled={
                            !taskRecordUrls.length ||
                            taskRecordUrls[0].urlStatus === 2
                          }
                          onClick={() => {
                            if (!taskRecordUrls || !taskRecordUrls.length) {
                              this.$message.error('无下载数据');
                              return;
                            }
                            if (taskRecordUrls.length === 1) {
                              this.$downloadFile(
                                taskRecordUrls[0].downloadUrl,
                                true,
                                taskRecordUrls[0].downloadName
                              );
                              return;
                            }
                            if (taskRecordUrls.length > 1) {
                              this.$xrkDialog({
                                showConfirm: false,
                                showCancel: true,
                                cancelText: '关闭',
                                width: '700px',
                                title: '下载列表',
                                $slots: {
                                  default: this.$createElement(DownloadList, {
                                    props: {
                                      tableData: taskRecordUrls
                                    }
                                  })
                                }
                              });
                            }
                          }}
                        >
                          任务记录{getText(taskRecordStatus)}
                        </el-button>
                        <el-button
                          type="text"
                          style={getStyle(dataStatus)}
                          onClick={open.bind(null, dataUrl || dataurl)}
                        >
                          数据报表{getText(dataStatus)}
                        </el-button>
                      </div>
                    );
                  }
                }
              ]
            }
          ]
        }
      ]
    };
  },
  computed: {
    ...mapState({
      homeProject: state => state.homeProject
    }),
    isOldBi() {
      return [2, 9, 10].includes(this.homeProject.projectType);
    }
  },
  methods: {
    openBi(status, res) {
      if (status != 2) {
        return;
      }
      const { id } = this.$route.query;
      const { projectType } = this.homeProject;
      if (!this.isOldBi) {
        this.$openV3BI({
          id: res.biInfoId,
          selectType: [5, 20].includes(+projectType) ? 203 : 44, // 老版调用老接口，注意selectType不一样
          projectType,
          projectId: id
        });
      } else {
        biBase
          .getFenpeiIdList({
            projectId: id,
            startTime: res.startTime,
            endTime: res.endTime,
            type: 3
          })
          .then(res => {
            const fenpeiIds = res.data.data.map(item => item.id);
            const biRoute = this.$router.resolve({
              name: 'bi-old',
              query: {
                fenpeiIdArr: fenpeiIds,
                serviceType: chartsType(projectType),
                projectId: id
              }
            });
            window.open(biRoute.href, '_blank');
          });
      }
    },
    create() {
      if (this.isloading) {
        return;
      }
      const [startTime, endTime] = this.value2 || [];
      const { id } = this.$route.query;
      const { projectType } = this.homeProject;
      const keyName = `custom-bi-${id}-${startTime}-${endTime}`;
      const nowTime = new Date().getTime();
      const oldTime = localStorage.getItem(keyName);
      if (oldTime && nowTime - oldTime < 5 * 60 * 1000) {
        this.$message.error('5分钟之内不能重复提交相同的内容申请');
        return;
      }
      this.isloading = true;

      let fn = null;
      if ([5, 20].includes(+projectType)) {
        fn = biBase.saveTSaasBiCustomReportV2;
      } else {
        fn = biBase.saveTSaasBiCustomReport;
      }

      fn({
        projectId: id,
        projectType,
        startTime: startTime ? dateFormat(startTime, 'YYYY-MM-DD') : undefined,
        endTime: endTime ? dateFormat(endTime, 'YYYY-MM-DD') : undefined
      })
        .then(() => {
          localStorage.setItem(keyName, nowTime);
          this.$message.success('生成成功');
          this.$refs['tableRender'].reGetPage();
          this.isloading = false;
        })
        .catch(() => {
          this.isloading = false;
        });
    }
  },
  created() {
    biBase
      .getCustomReportStartTime({
        projectId: this.homeProject.id
      })
      .then(res => {
        this.startTime = res.data.data.startDt;
        this.endTime = res.data.data.endDt;
        this.value2 = [new Date(this.startTime), new Date()];
      });
  }
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-date-editor .el-range-separator {
    padding: 0;
  }
}
.header {
  text-align: left;
  padding: 0 1.56vw;
  font-size: 20px;
}
.top {
  // display: flex;
  // justify-content: center;
  // align-items: center;
  & > div {
    padding: 0 40px;
    width: 700px;
    & + div {
      margin-top: 20px;
    }
    .title {
      display: inline-block;
      width: 100px;
    }
  }
}
</style>
